import type {RouteLocationNormalized} from 'vue-router';
import {defineNuxtRouteMiddleware, navigateTo, IMMERSION_QUERY_PARAM} from '#imports';

const QUERY_PARAMS_TO_FORWARD = ['origin', 'pageSource', IMMERSION_QUERY_PARAM];

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    const queryParamsToPreserve = Object.keys(from.query)
        .filter((paramName) => !to.query[paramName] && QUERY_PARAMS_TO_FORWARD.includes(paramName))
        .reduce((accumulator, paramName) => ({...accumulator, [paramName]: from.query[paramName]}), {});

    if (Object.keys(queryParamsToPreserve).length === 0) {
        return;
    }

    return navigateTo({
        path: to.path,
        query: {
            ...queryParamsToPreserve,
            ...to.query,
        },
    });
});
